export function formatCurrency(price: number, currency: string): string {
  return `${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${currency}`;
}